import { render, staticRenderFns } from "./string-text.vue?vue&type=template&id=5523f2c8"
import script from "./string-text.vue?vue&type=script&lang=js"
export * from "./string-text.vue?vue&type=script&lang=js"
import style0 from "./string-text.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/common/content/string/string-text.vue
// module id = ILms
// module chunks = 0